// Drafts often come back with the sport slug, the "## headline" and the first
// paragraph on consecutive lines ("ALPINISM\n## Title\nProse…"). The email
// builder and editor fold single newlines into spaces, which glued those into
// one unstyled line. Give every heading its own block first.
export function ensureBlockBreaks(text) {
  return (text || '')
    .replace(/([^\n])\n(#{1,2} )/g, '$1\n\n$2')          // heading directly under a line
    .replace(/^(#{1,2} [^\n]*)\n(?=[^\n])/gm, '$1\n\n')   // heading directly above a line
}

// Web-search drafts sometimes open with the model's working notes ("Good, I now
// have material… Let me compile what I know: …") before the story itself.
// Keep only the story: from its "## headline" line, plus a sport slug directly above it.
export function extractStory(text, headline) {
  const raw = (text || '').trim()
  const lines = raw.split('\n')
  const key = (headline || '').trim().slice(0, 25).toLowerCase()
  let h = key ? lines.findIndex(l => /^## /.test(l) && l.toLowerCase().includes(key)) : -1
  if (h === -1) h = lines.findIndex(l => /^## /.test(l))
  if (h <= 0) return raw
  let start = h
  for (let i = h - 1; i >= 0; i--) {
    if (!lines[i].trim()) continue
    if (/^[A-Z0-9 &/'’.-]{2,40}$/.test(lines[i].trim())) start = i
    break
  }
  return lines.slice(start).join('\n').trim()
}
